module.exports = {
  dish1: {
    name: "Mexican 1",
    description: "Insert Mexican 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Mexican 2",
    description: "Insert Mexican 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Mexican 3",
    description: "Insert Mexican 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Mexican 4",
    description: "Insert Mexican 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Mexican 5",
    description: "Insert Mexican 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Mexican 6",
    description: "Insert Mexican 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Mexican 7",
    description: "Insert Mexican 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Mexican 8",
    price: 4400,
    description: "Insert Mexican 8 description",
    status: "available"
  },
  dish9: {
    name: "Mexican 9",
    price: 3300,
    description: "Insert Mexican 9 description",
    status: "available"
  },
  dish10: {
    name: "Mexican 10",
    price: 3900,
    description: "Insert Mexican 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/FatCactus.js